<template>
  <div>
    <Landing />
    <LandingDetails />
    <LandingGoalGuide/>
    <LiveStream />
    <LandingSpeaker />
    <LandingPartners />
    <LandingSponsor />
    <LandingTopics />
    <RegisterSubmit />
  </div>
</template>

<script>
import Landing from '@/components/Landing.vue';
import LandingDetails from '@/components/LandingDetails.vue';
import LandingSpeaker from '@/components/LandingSpeaker.vue';
import LandingPartners from '@/components/LandingPartners.vue';
import LandingSponsor from '@/components/LandingSponsor.vue';
import LandingGoalGuide from '@/components/LandingGoalGuide.vue';
import LandingTopics from '@/components/LandingTopics.vue';
import RegisterSubmit from '@/components/RegisterSubmit.vue';
import LiveStream from '@/components/LiveStream.vue';

export default {
  name: 'Home',
  components: {
    Landing,
    LandingDetails,
    LandingSpeaker,
    LandingPartners,
    LandingSponsor,
    LandingGoalGuide,
    LandingTopics,
    RegisterSubmit,
    LiveStream,
  },
};
</script>
